<template>
  <div>
    <div class="input-group" :style="fieldStyles()">
      <field-icon :fieldData="fieldData"></field-icon>

      <input
      :disabled="(!!showDisabled())"
      :name="fieldData.field_name"
      type="text"
      :id="fieldData.field_name"
      :placeholder="fieldData.placeholder"
      :ref="fieldData.field_name"
      :maxlength="fieldData.max_length"
      :aria-describedby="`${fieldData.field_name}_describedby`"
      @click="triggerPlacesAutocomplete"
      @keydown="triggerPlacesAutocomplete"
      @keyup="triggerPlacesAutocomplete"
      @focus="triggerPlacesAutocomplete"
      @blur="triggeronblur"
      @change="apiRule.present && apiRule.type == 'onchange' ? postRule($event.target.value, fieldData) :  ''"
      v-validate="field_rules"
      v-model="fieldData.field_value"
      v-bind:class="{'form-control': true, 'w-100': true, 'error error-style': errors.has(fieldData.field_name) || fieldData.has_error || $store.invalidPostalState }"
      />

      <input
      :disabled="(!!showDisabled())"
      type="text"
      class="form-control"
      :ref="'actualSearchInputField'"
      name="actualSearchInputField"
      id="actualSearchInputField"
      style="visibility: hidden; height: 0; padding-top: 0; padding-bottom: 0; margin-top: 0; margin-bottom: 0; border: none"
      />
       <span v-bind:class="{'warning fas fa-exclamation-triangle': errors.has(fieldData.field_name)  || fieldData.has_error }"></span>
      </div>

      <div class="form-row mx-0">
        <div
        v-show="showAddressError"
        class="text-danger px-2"
        v-html="showAddressError"
        ></div>
      </div>
    </div>
</template>

<script>
/* eslint-disable */

import FieldIcon from '../presentational/FieldIcon';
import { inputFieldMixin } from '../../mixins/inputFieldMixin';
import { googleAddressAutoComplete } from '../interview/shared/google-places-integration';

export default {
  inject: ['$validator'], // Allows this component's validation messages to appear in other components
  props: ['fieldData', 'inputType'],
  components: { FieldIcon },
  mixins: [inputFieldMixin],
  methods: {
    triggerPlacesAutocomplete() {
      if (this.fieldData.field_value.length > 0) { // Only show autocomplete list if there is input
        this.$refs.actualSearchInputField.value = `USA, ${this.$store.postalState}, ${this.fieldData.field_value}`;
        google.maps.event.trigger(this.$refs.actualSearchInputField, 'focus', {});
      }
    },
    places_autocomplete_init() {
      if (this.fieldData.field_type === 'address_long' && this.fieldData.visible) {
        googleAddressAutoComplete(this, this.$router.currentRoute, 'fieldData');
      }
    },
    triggeronblur(){
      console.log('apiRule.present',this.apiRule.present);
      google.maps.event.trigger(document.getElementById('actualSearchInputField'), 'blur', {});
      if(this.apiRule.present && this.apiRule.type == 'onblur'){
        postRule($event.target.value, this.fieldData);
      }
    }
  },
  computed: {
    showAddressError() {
      return this.$store.state.commonState.showAddressError;
    },
    is_visible() {
      return this.fieldData.visible;
    },
    isEmpty() {
      return (this.fieldData.field_value === '' || this.fieldData.field_value === 'Invalid date' || this.fieldData.field_value === null);
    },
  },
  watch: {
    /**
     * When visible updates from false -> true, set up Places Autocomplete, if necessary
     */
    is_visible: function (newValue, oldValue) {
      if (!oldValue && newValue) {
        this.places_autocomplete_init();
      }
    },
  },
  mounted() {
    this.places_autocomplete_init(); // Sets up Places Autocomplete, if necessary
  },
};
</script>

<style scoped>
.error-style{
  width:87% !important;  
}
i.warning.fas.fa-exclamation-triangle{
    margin-left:-8% !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/interactive/InputAddress.vue?3529a3df